import { gunterzBlack } from '@/theme/fonts';
import { Box, Image, Stack, Text } from '@mantine/core';
import classes from './CategoryCard.module.css';
type CategoryCardProps = {
  image: string;
  colorFrom: string;
  colorTo: string;
  title: string;
  des: string;
  flag?: boolean;
};
export const CategoryCard: React.FC<CategoryCardProps> = ({
  image,
  colorFrom,
  colorTo,
  title,
  des
}) => {
  return <Stack bg="var(--navbar-bg-color)" gap={0} className={classes.radius}>
      <Box>
        <Image src={image} className={classes.imageTrans} alt={title} />
      </Box>

      <Stack align="center" gap={0} p={12} mih={120}>
        <Text tt="uppercase" fz={{
        base: 'sm',
        md: 'md',
        lg: 'xl'
      }} variant="gradient" gradient={{
        from: `${colorFrom}`,
        to: `${colorTo}`,
        deg: 135
      }} className={gunterzBlack.className}>
          {title}
        </Text>
        <Text tt="uppercase" fz={{
        base: 10,
        md: 12
      }} fw={700} ta="center" c="var(--text-dark)" lineClamp={3}>
          {des}
        </Text>
      </Stack>
    </Stack>;
};